import { createContext } from "react";

const OrderMasterContext = createContext({});

export default OrderMasterContext;
